import { Navigate, Outlet } from 'react-router-dom';
import { useAuthContext } from './auth-context';

export const PrivateRoute = ({ children }) => {
  const { isLoggedIn } = useAuthContext();
  if (!isLoggedIn) {
    return <Navigate to="authentication/login" replace />;
  }

  return children ? children : <Outlet />;
};
